import { Stack, Typography } from '@mui/material';
import React from 'react';
import { useDispatch } from 'react-redux';
import styles from './RequestStatus.module.scss';
import { ReactComponent as Check } from 'src/new/components/icons/fi-rr-check.svg';
import { ReactComponent as Cross } from 'src/new/components/icons/fi-sr-cross.svg';
import { ReactComponent as ClockIcon } from 'src/new/components/icons/fi-rr-clock.svg';
import { Button } from '../Button';
import { approveAccessRequest, rejectAccessRequest } from 'js/actions';

interface RequestStatusProps {
  status: 'pending' | 'approved' | 'denied';
  selected_tab: 'outgoing' | 'incoming';
  request_type: string;
  datasetId: number;
}

const RequestStatus = (props: RequestStatusProps) => {
  const { status, datasetId, selected_tab, request_type } = props;
  const dispatch = useDispatch();

  const statusMapping = {
    approved: {
      label: 'Approved',
      icon: <Check />,
    },
    rejected: {
      label: 'Declined',
      icon: <Cross />,
    },
    pending: {
      label: 'Pending',
      icon: <ClockIcon />,
    },
  };

  const onCancel = () => {
    // WIP need api call for canceling pending req.
  };

  const onApprove = (id: number) => {
    dispatch(approveAccessRequest(id, request_type));
  };

  const onReject = (id: number) => {
    dispatch(rejectAccessRequest(id, request_type));
  };
  // WIP: request cancellation commented out until api fix
  if (selected_tab === 'outgoing') {
    return (
      <>
        {/* {status === 'pending' ? (
          <Button
            size="small"
            variant="outlined"
            color="error"
            endIcon={statusMapping[status].icon}
            onClick={onCancel}>
            Cancel Request
          </Button>
        ) : ( */}
        <Stack
          alignItems="center"
          direction="row"
          gap="6px"
          className={`${styles[`status--${status}`]}`}
        >
          {statusMapping[status]?.icon}
          <Typography variant="body2" color="currentColor">
            {statusMapping[status]?.label}
          </Typography>
        </Stack>
        {/* )} */}
      </>
    );
  } else if (selected_tab === 'incoming') {
    return (
      <>
        {status === 'pending' ? (
          <div className={styles.buttonGroup}>
            <Button
              size="small"
              variant="ghost"
              className={styles.approve}
              onClick={() => onApprove(datasetId)}
            >
              Approve
            </Button>
            <Button
              size="small"
              variant="outlined"
              className={styles.reject}
              onClick={() => onReject(datasetId)}
            >
              Decline
            </Button>
          </div>
        ) : null}
      </>
    );
  }
};

export default RequestStatus;
